var _excluded = ["filters", "orderBy", "steps", "propertyNames"];

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { all, select, takeLatest, takeEvery, getContext, fork, spawn, take, join, put } from 'redux-saga/effects';
import { createTree } from '@keen.io/ui-core';
import { setQueryReadiness, fetchProjectDetails, fetchProjectDetailsSuccess, fetchProjectDetailsError, APP_START, FETCH_PROJECT_DETAILS } from './modules/app';
import { getOrderBy, setFunnelSteps, setFunnelStepFilters, setPropertyNames, setGroupBy, setOrderBy, setFilters, setQuery, postProcessingFinished, SET_GROUP_BY, SERIALIZE_QUERY, SELECT_EVENT_COLLECTION, SELECT_FUNNEL_STEP_EVENT_COLLECTION } from './modules/query';
import { fetchCollectionSchema, fetchCollectionSchemaSuccess, fetchCollectionSchemaError, setEventsCollections, setCollectionSchemaLoading, getSchemas, computeSchemaSuccess, FETCH_COLLECTION_SCHEMA_SUCCESS, FETCH_COLLECTION_SCHEMA, SCHEMA_COMPUTED } from './modules/events';
import { serializeOrderBy, serializeFilters, serializeFunnelSteps, serializePropertyNames } from './serializers';
import { createCollection, useQueryPostProcessing } from './utils';
import { timezoneSaga, timezoneActions, getDefaultTimezone } from './modules/timezone';

function* appStart() {
  yield put(fetchProjectDetails());
  yield put(timezoneActions.fetchTimezones());
}

function* fetchProject() {
  var client = yield getContext('keenClient');

  try {
    var url = client.url('/3.0/projects/{projectId}', {
      api_key: client.config.masterKey
    });

    var _yield$fetch$then = yield fetch(url).then(function (response) {
      return response.json();
    }),
        events = _yield$fetch$then.events;

    var collections = events.map(function (_ref) {
      var name = _ref.name;
      return name;
    });
    yield put(fetchProjectDetailsSuccess());
    yield put(setEventsCollections(collections));
  } catch (err) {
    yield put(fetchProjectDetailsError(err));
  }
}

function* transformSchema(collection, properties) {
  var tree = yield createTree(properties);
  var list = yield createCollection(properties);
  var schema = {
    tree: tree,
    list: list
  };
  yield put(computeSchemaSuccess(collection, schema));
}

function* fetchSchema(action) {
  var collection = action.payload.collection;
  var client = yield getContext('keenClient');
  yield put(setCollectionSchemaLoading(collection, true));

  try {
    var url = client.url("/3.0/projects/{projectId}/events/".concat(collection), {
      api_key: client.config.masterKey
    });

    var _yield$fetch$then2 = yield fetch(url).then(function (response) {
      return response.json();
    }),
        properties = _yield$fetch$then2.properties;

    yield put(fetchCollectionSchemaSuccess(collection, properties));
    yield spawn(transformSchema, collection, properties);
  } catch (err) {
    yield put(fetchCollectionSchemaError(err));
  } finally {
    yield put(setCollectionSchemaLoading(collection, false));
  }
}

export function* selectCollection(action) {
  var collection = action.payload.name;

  if (collection) {
    var schemas = yield select(getSchemas);
    var isSchemaExist = schemas[collection];

    if (!isSchemaExist) {
      yield put(fetchCollectionSchema(collection));
    }
  }

  yield put(setGroupBy(undefined));
  yield put(setOrderBy(undefined));
  yield put(setPropertyNames(undefined));
  yield put(setFilters([]));
}

function* selectFunnelStepCollection(action) {
  var collection = action.payload.name;
  var schemas = yield select(getSchemas);
  var isSchemaExist = schemas[collection];
  if (!isSchemaExist) yield put(fetchCollectionSchema(collection));
}

function* storeEventSchemas() {
  var schemas = yield select(getSchemas);
  window.__QUERY_CREATOR_SCHEMAS__ = schemas;
}

export function* transformFilters(collection, filters) {
  var schemas = yield select(getSchemas);
  var collectionSchema = schemas[collection];

  if (!collectionSchema) {
    while (true) {
      yield take(FETCH_COLLECTION_SCHEMA_SUCCESS);
      schemas = yield select(getSchemas);

      if (schemas[collection]) {
        collectionSchema = schemas[collection];
        break;
      }
    }
  }

  var _collectionSchema = collectionSchema,
      schema = _collectionSchema.schema;
  var filtersSettings = serializeFilters(filters, schema);
  yield put(setFilters(filtersSettings));
}
export function* transformStepFilters(collection, filters, stepId) {
  var schemas = yield select(getSchemas);
  var collectionSchema = schemas[collection];

  if (!collectionSchema) {
    while (true) {
      yield take(FETCH_COLLECTION_SCHEMA_SUCCESS);
      schemas = yield select(getSchemas);

      if (schemas[collection]) {
        collectionSchema = schemas[collection];
        break;
      }
    }
  }

  var _collectionSchema2 = collectionSchema,
      schema = _collectionSchema2.schema;
  var filtersSettings = serializeFilters(filters, schema);
  yield put(setFunnelStepFilters(stepId, filtersSettings));
}
export function* transformOrderBy(orderBy) {
  var orderBySettings = serializeOrderBy(orderBy);
  yield put(setOrderBy(orderBySettings));
}
export function* transformPropertyNames(propertyNames) {
  var propertiesSettings = serializePropertyNames(propertyNames);
  yield put(setPropertyNames(propertiesSettings));
}

function* serializeQuery(action) {
  var query = action.payload.query;
  var schemas = yield select(getSchemas);
  var usePostProcessing = useQueryPostProcessing(query);
  var transformTasks = [];
  yield put(setQueryReadiness(!usePostProcessing));

  var filters = query.filters,
      orderBy = query.orderBy,
      steps = query.steps,
      propertyNames = query.propertyNames,
      querySettings = _objectWithoutProperties(query, _excluded);

  var initialQuery = _objectSpread({}, querySettings);

  var defaultTimezone = yield select(getDefaultTimezone);

  if (!query.timezone) {
    initialQuery.timezone = defaultTimezone;
  }

  yield put(setQuery(initialQuery));

  if (query.eventCollection && !schemas[query.eventCollection]) {
    yield put(fetchCollectionSchema(query.eventCollection));
  }

  if (steps) {
    var _serializeFunnelSteps = serializeFunnelSteps(steps),
        transformedSteps = _serializeFunnelSteps.transformedSteps,
        stepsFilters = _serializeFunnelSteps.stepsFilters;

    yield put(setFunnelSteps(transformedSteps));

    if (stepsFilters && stepsFilters.length) {
      var stepFiltersTask = yield all(stepsFilters.map(function (_ref2) {
        var eventCollection = _ref2.eventCollection,
            filters = _ref2.filters,
            id = _ref2.id;
        return fork(transformStepFilters, eventCollection, filters, id);
      }));
      transformTasks.push.apply(transformTasks, _toConsumableArray(stepFiltersTask));
    }

    var schemasToFetch = steps.filter(function (_ref3) {
      var eventCollection = _ref3.eventCollection;
      return !schemas[eventCollection];
    }).map(function (_ref4) {
      var eventCollection = _ref4.eventCollection;
      return eventCollection;
    });
    yield all(schemasToFetch.map(function (eventCollection) {
      return put(fetchCollectionSchema(eventCollection));
    }));
  }

  if (propertyNames) {
    var propertyTask = yield fork(transformPropertyNames, propertyNames);
    transformTasks.push(propertyTask);
  }

  if (filters) {
    var filtersTask = yield fork(transformFilters, query.eventCollection, filters);
    transformTasks.push(filtersTask);
  }

  if (orderBy) {
    var orderByTask = yield fork(transformOrderBy, orderBy);
    transformTasks.push(orderByTask);
  }

  if (usePostProcessing) {
    yield join(transformTasks);
    yield put(setQueryReadiness(true));
    yield put(postProcessingFinished());
  }
}

function* updateGroupBy(action) {
  var groupBy = action.payload.groupBy;
  var orderBy = yield select(getOrderBy);
  var orderBySettings;

  if (groupBy && orderBy && groupBy.length && Object.keys(orderBy).length) {
    orderBySettings = orderBy.filter(function (_ref5) {
      var propertyName = _ref5.propertyName;
      return groupBy.includes(propertyName) || propertyName === 'result';
    });
  }

  yield put(setOrderBy(orderBySettings));
}

function* watcher() {
  yield takeLatest(APP_START, appStart);
  yield takeLatest(SERIALIZE_QUERY, serializeQuery);
  yield takeLatest(FETCH_PROJECT_DETAILS, fetchProject);
  yield takeEvery(FETCH_COLLECTION_SCHEMA, fetchSchema);
  yield takeLatest(SELECT_EVENT_COLLECTION, selectCollection);
  yield takeLatest(SCHEMA_COMPUTED, storeEventSchemas);
  yield takeLatest(SELECT_FUNNEL_STEP_EVENT_COLLECTION, selectFunnelStepCollection);
  yield takeLatest(SET_GROUP_BY, updateGroupBy);
}

export default function* rootSaga() {
  yield all([watcher(), timezoneSaga()]);
}